import { useEffect } from "react";

export function PWAUpdateManager() {
  useEffect(() => {
    if (!("serviceWorker" in navigator) || !window.location.protocol.startsWith("http")) {
      return;
    }

    let intervalId: number | undefined;

    navigator.serviceWorker.ready.then((registration) => {
      // If a worker is already waiting, tell it to activate immediately
      if (registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }

      // If a new worker installs, signal it to activate automatically
      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed") {
            newWorker.postMessage({ type: "SKIP_WAITING" });
          }
        });
      });

      // Background update check when user focuses or returns to the tab
      const onVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          registration.update().catch(() => {});
        }
      };

      document.addEventListener("visibilitychange", onVisibilityChange);

      // Periodic check every 60 minutes
      intervalId = window.setInterval(() => {
        registration.update().catch(() => {});
      }, 60 * 60 * 1000);

      return () => {
        document.removeEventListener("visibilitychange", onVisibilityChange);
      };
    });

    return () => {
      if (intervalId) window.clearInterval(intervalId);
    };
  }, []);

  return null;
}
